import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  height: 100%;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const NavigationBlock = styled.div`
  height: 50px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
`;

export const Depth = styled.div`
  margin-right: auto;
`;

export const Body = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${ColorSF2.white};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const List = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

export const ListItem = styled.div`
  height: 30px;
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  background-color: ${props =>
    props.selected ? ColorSF2.skyBlue : ColorSF2.paleBlue};
  padding: 0px 10px;
  justify-content: start;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    background-color: ${ColorSF2.lightBlue};
  }
}
`;

export const UnavailableDiv = styled.div`
  width: 52px;
  height: 20px;
  line-height: 10px;
  margin-right: 8px;
  padding: 5px 6px;
  display: flex;
  justify-content: center;
  background-color: ${ColorSF2.charcoalGray};
  border-radius: 2px;
  font-size: 10px;
  color: ${ColorSF2.white};
`;

export const TagName = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EditButton = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 15px;
  opacity: ${props => (props.disabled ? 0.2 : 1)};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

export const AddButton = styled(EditButton)``;
